<div *ngIf="loading">
  <loading-widget></loading-widget>
</div>
